// extracted by mini-css-extract-plugin
export default {"tileBtn":"JobOfferForm-AddButton__tileBtn--XF6Pk","shortBtn":"JobOfferForm-AddButton__shortBtn--yOcKM"};